import { Create } from "react-admin";
import { MealForm } from "./form";

export const MealCreate = () => (
  <Create title="Create meal" redirect="list">
    <MealForm source="name" />
  </Create>
);
